import { __decorate } from "tslib";
import { lazyProvider } from '@1inch-community/core/lazy';
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SceneContext } from './scene-context';
import { sceneContext } from './scene-context.token';
let SceneWrapperElement = class SceneWrapperElement extends LitElement {
    constructor() {
        super(...arguments);
        this.context = lazyProvider(this, {
            context: sceneContext,
            initialValue: new SceneContext(),
        });
    }
    static { this.tagName = 'inch-scene-wrapper'; }
    static { this.styles = css `
    :host {
      background-color: var(--scene-background-color);
      will-change: transform;
      transform: translate3d(0, 0, 0);
      height: fit-content;
      max-height: 100%;
      box-sizing: border-box;
      position: relative;
      display: block;
      flex-grow: 1;
    }
  `; }
    get contextValue() {
        return this.context.value;
    }
    animationInStart() {
        this.contextValue.animationInStartNext();
    }
    animationInEnd() {
        this.contextValue.animationInEndNext();
    }
    animationOutStart() {
        this.contextValue.animationOutStartNext();
    }
    animationOutEnd() {
        this.contextValue.animationOutEndNext();
    }
    render() {
        return html `<slot></slot>`;
    }
};
SceneWrapperElement = __decorate([
    customElement(SceneWrapperElement.tagName)
], SceneWrapperElement);
export { SceneWrapperElement };
//# sourceMappingURL=scene-wrapper.element.js.map